import { TableData, TableDataTypes, Toaster, ToasterType } from './types';
import { CAPTAIN_TICKET_DISPOSITIONS } from './constants';
import { TicketConversationDialogComponent } from './ticket-conversation-dialog.component';
export var TICKET_LINK_TD_CLASS = 'cursor-pointer whiteSpacePre table-link-cell';
export var TICKET_LINK_SPAN_CLASS = 'table-link-btn';
export var TICKET_DEFAULT_TD_CLASS = '';
export var TICKET_BOOKING_ID_QUERY_CHUNK_SIZE = 50;
export var TICKET_V2_DEFAULT_PAGE_SIZE = 30;
export var TICKET_V2_ALL_PAGES = 0;
export var TICKET_CONVERSATION_DIALOG_WIDTH = '720px';
export var TICKET_CONVERSATION_COMMENT_LIMIT = 100;
var RD_ORDER_ID_PATTERN = /^RD/i;
export function chunkList(items, size) {
    if (!Array.isArray(items) || !size || size < 1) {
        return [];
    }
    var chunks = [];
    for (var index = 0; index < items.length; index += size) {
        chunks.push(items.slice(index, index + size));
    }
    return chunks;
}
export function mergeTicketLists(ticketLists) {
    return (ticketLists || []).reduce(function (all, tickets) { return all.concat(tickets || []); }, []);
}
export function paginateTicketList(tickets, pageNumber, pageSize) {
    if (pageSize === void 0) { pageSize = TICKET_V2_DEFAULT_PAGE_SIZE; }
    var items = tickets || [];
    var size = pageSize > 0 ? pageSize : items.length;
    if (!size) {
        return [];
    }
    var page = pageNumber > 0 ? pageNumber : 1;
    var start = (page - 1) * size;
    return items.slice(start, start + size);
}
export function shouldFetchNextTicketPage(tickets, pageSize) {
    if (pageSize === void 0) { pageSize = TICKET_V2_DEFAULT_PAGE_SIZE; }
    return Array.isArray(tickets) && tickets.length >= pageSize;
}
export function buildMobileTicketQuery(mobile) {
    return JSON.stringify({ mobile: mobile });
}
export function normalizeTicketDescription(descriptionText) {
    return descriptionText ? descriptionText.replace(/ +(?= )/g, '') : null;
}
export function createTicketLinkTableData(ticketId, redirectionUrl) {
    return createTicketActionTableData(ticketId, function () {
        if (redirectionUrl) {
            window.open(redirectionUrl, '_blank', 'noopener,noreferrer');
        }
    });
}
export function createTicketActionTableData(label, onClick) {
    return new TableData({
        data: label,
        type: TableDataTypes.DATA,
        tdClassName: TICKET_LINK_TD_CLASS,
        spanClassName: TICKET_LINK_SPAN_CLASS,
        stopHover: true,
        onClick: onClick,
    });
}
function normalizeTicketId(value) {
    if (value == null) {
        return '';
    }
    var trimmed = String(value).trim();
    if (!trimmed || trimmed.toUpperCase() === 'NA') {
        return '';
    }
    return trimmed;
}
export function getTicketRdOrderId(ticket, fallbackOrderId) {
    var candidates = [
        ticket && ticket.rd_order_id,
        ticket && ticket.uniqueId,
        fallbackOrderId,
    ];
    for (var index = 0; index < candidates.length; index++) {
        var trimmed = normalizeTicketId(candidates[index]);
        if (isRdOrderId(trimmed)) {
            return trimmed;
        }
    }
    return '';
}
export function isRdOrderId(value) {
    return !!value && RD_ORDER_ID_PATTERN.test(value);
}
export function getTicketBookingId(ticket) {
    var bookingId = normalizeTicketId(ticket && ticket.booking_id);
    if (bookingId) {
        return bookingId;
    }
    var rdOrderId = normalizeTicketId(ticket && ticket.rd_order_id);
    if (rdOrderId && !isRdOrderId(rdOrderId)) {
        return rdOrderId;
    }
    return '';
}
export function createTicketOrderIdCells(ticket, fallbackRdOrderId) {
    return {
        rdOrderId: createTicketTableData(getTicketRdOrderId(ticket, fallbackRdOrderId)),
        orderId: createTicketTableData(getTicketBookingId(ticket)),
    };
}
export function createTicketConversationCell(onClick) {
    return createTicketActionTableData('View', onClick);
}
export function mapBookingIdToRdOrderId(orders) {
    var rdOrderIdByBookingId = {};
    (orders || []).forEach(function (order) {
        if (order && order._id && order.uniqueId) {
            rdOrderIdByBookingId[order._id] = order.uniqueId;
        }
    });
    return rdOrderIdByBookingId;
}
export function collectBookingIds(orders) {
    return (orders || []).map(function (order) { return order && order._id; }).filter(Boolean);
}
export function filterCaptainIssueTickets(tickets, allowedSubReasons) {
    if (Array.isArray(allowedSubReasons) && allowedSubReasons.includes('all')) {
        return (tickets || []).filter(function (ticket) { return !!(ticket && ticket.sub_reason918254); });
    }
    return (tickets || []).filter(function (ticket) { return isAllowedCaptainIssueSubReason(ticket && ticket.sub_reason918254, allowedSubReasons); });
}
export function buildConversationDialogData(ticketId, response, formatDate, userLabel) {
    if (userLabel === void 0) { userLabel = 'Captain'; }
    return {
        title: ticketId ? "Conversation \u2014 " + ticketId : 'Conversation',
        messages: buildTicketConversation(response, formatDate, userLabel),
    };
}
export function openTicketConversation(_a) {
    var ticketingService = _a.ticketingService, dialog = _a.dialog, toasterService = _a.toasterService, userId = _a.userId, ticketId = _a.ticketId, formatDate = _a.formatDate, _b = _a.userLabel, userLabel = _b === void 0 ? 'Captain' : _b;
    ticketingService.fetchTicketConversation(userId, ticketId).subscribe(function (response) {
        dialog.open(TicketConversationDialogComponent, {
            width: TICKET_CONVERSATION_DIALOG_WIDTH,
            data: buildConversationDialogData(ticketId, response, formatDate, userLabel),
        });
    }, function () {
        toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: "Error while getting comments for ticket " + ticketId,
            delay: 3000,
        }));
    });
}
export function isAllowedCaptainIssueSubReason(subReason, allowedSubReasons) {
    return !!subReason && Array.isArray(allowedSubReasons) && allowedSubReasons.includes(subReason);
}
export function isCaptainProfileTicket(ticket) {
    return ticket.ticket_source === 'chatService' ||
        !!(ticket.l1_agent_action && CAPTAIN_TICKET_DISPOSITIONS.includes(ticket.l1_agent_action));
}
export function resolveTicketHoverData(hoverData, value) {
    if (hoverData != null) {
        return hoverData;
    }
    if (value != null) {
        return value;
    }
    return '';
}
export function createTicketTableData(value, className, type, flag, hoverData) {
    if (className === void 0) { className = TICKET_DEFAULT_TD_CLASS; }
    if (flag === void 0) { flag = false; }
    return new TableData({
        data: value,
        type: type ? type : TableDataTypes.DATA,
        flag: flag,
        hoverData: resolveTicketHoverData(hoverData, value),
        tdClassName: className,
    });
}
export function getTicketPaginationCount(pageNo, perPage, ticketsInPage) {
    if (ticketsInPage >= perPage) {
        return (pageNo + 1) * perPage + 1;
    }
    return pageNo * perPage + ticketsInPage;
}
export function extractTicketComments(response) {
    if (!response) {
        return [];
    }
    if (Array.isArray(response)) {
        return response;
    }
    if (Array.isArray(response.data)) {
        return response.data;
    }
    if (response.comments && Array.isArray(response.comments.data)) {
        return response.comments.data;
    }
    if (Array.isArray(response.comments)) {
        return response.comments;
    }
    return [];
}
export function getConversationSpeaker(comment, userLabel) {
    if (userLabel === void 0) { userLabel = 'Captain'; }
    if (!comment) {
        return 'Unknown';
    }
    if (comment.category === 2 || comment.private) {
        return 'Private note';
    }
    if (comment.is_agent === 1 || comment.category === 3) {
        return 'Agent';
    }
    return userLabel || 'Captain';
}
export function getConversationSide(speaker) {
    if (speaker === 'Agent') {
        return 'agent';
    }
    if (speaker === 'Private note') {
        return 'note';
    }
    return 'captain';
}
export function buildTicketConversation(response, formatDate, userLabel) {
    if (userLabel === void 0) { userLabel = 'Captain'; }
    var formatTime = formatDate || (function (value) { return value; });
    return extractTicketComments(response)
        .slice()
        .sort(function (a, b) { return new Date(a.created_at).getTime() - new Date(b.created_at).getTime(); })
        .map(function (comment) {
        var speaker = getConversationSpeaker(comment, userLabel);
        return {
            speaker: speaker,
            side: getConversationSide(speaker),
            text: comment.body_text || comment.body || '',
            time: comment.created_at ? formatTime(comment.created_at) : '',
        };
    });
}
